function MenuItem({text, onClick}) {
  return (
    <div className={'menuItem'} onClick={onClick}>
      {text}
    </div>
  );
}

export default MenuItem;
